import * as React from 'react';

import {portal} from 'shells/portal/portal';

import './swoop-arrow.module.css';

type Props = {
    startSelector: string;
    destinationSelector: string;
};

type State = {
    d: string;
};

/*
 * This guy is just an arrow that draws itself from the team image on the last slide of the
 * lifting-of-the-curtain modal down to the help button in the sidebar.
 * The line animation is using the method explained in https://css-tricks.com/svg-line-animation-works/,
 * and the inspiration for measuring the path length is https://codepen.io/gabriellewee/pen/EZPYmw.
 */
class SwoopArrowComponent extends React.Component<Props, State> {
    // These are SVG paths, but I'm not sure how to type them
    testPath: any;
    linePath: any;

    constructor() {
        // @ts-expect-error
        super();
        this.state = {
            d: '',
        };
    }

    componentDidMount() {
        window.addEventListener('resize', this.calculatePath);
        setTimeout(() => {
            this.calculatePath();
        }, 20);
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.calculatePath);
    }

    render() {
        return (
            <React.Fragment>
                <svg id='swoop-arrow' width='100%' height='100%'>
                    <defs>
                        <marker
                            id='arrowhead'
                            viewBox='0 0 58 40'
                            refX='10'
                            refY='21'
                            stroke='#fdd121'
                            fill='#fdd121'
                            markerWidth='10'
                            markerHeight='10'
                            orient='0'
                        >
                            <path
                                d='M41 2L4 24l50 14'
                                fillRule='nonzero'
                                strokeWidth='6'
                                fill='none'
                                strokeLinecap='round'
                                strokeLinejoin='round'
                            />
                        </marker>
                    </defs>
                    <g fill='none' stroke='#fdd121' strokeWidth='3' markerEnd='url(#arrowhead)'>
                        <path
                            ref={(node) => {
                                this.linePath = node;
                            }}
                            id='arrow-path'
                            d={this.state.d}
                            strokeLinecap='round'
                        />
                    </g>
                </svg>
                {/* This hidden SVG only exists to find the length of the path we are going to make */}
                <svg>
                    <path
                        ref={(node) => {
                            this.testPath = node;
                        }}
                        d=''
                    />
                </svg>
            </React.Fragment>
        );
    }

    calculatePath = () => {
        const teamImage = document.getElementById(this.props.startSelector);
        const helpButton = document.getElementById(this.props.destinationSelector);
        if (!teamImage || !helpButton) return null;
        const startRect = teamImage.getBoundingClientRect();
        const endRect = helpButton.getBoundingClientRect();
        const start = {x: startRect.left + startRect.width / 2, y: startRect.bottom + 20} as const;
        const end = {x: endRect.right + 20, y: endRect.top + endRect.height / 2} as const;
        const d =
            `M${start.x},${start.y} ` +
            `C${start.x},${start.y + 200} ${end.x + 200},${end.y} ${end.x},${end.y}`;
        // If this is an update, just set the `d` attribute, don't need to animate
        if (this.state.d) {
            this.setState({d});
            // Otherwise, this is the first time through, so try to find the length of the path so we can animate.
        } else if (this.testPath) {
            this.testPath.setAttribute('d', d);
            // Give the dom a little time to update our test path so we can then measure it.
            setTimeout(() => {
                if (this.testPath) {
                    const length = this.testPath.getTotalLength();
                    const total = Math.round(length);
                    if (total > 0) {
                        this.linePath.style.strokeDasharray = total;
                        this.linePath.style.strokeDashoffset = total;
                    }
                }
                this.setState({d});
            }, 100);
            // Clear styles set from animation, so we don't have problems if the window is expanded.
            setTimeout(() => {
                if (this.linePath) {
                    this.linePath.removeAttribute('style');
                }
            }, 2000);
        } else {
            // If we can't find a testPath element, just set the `d` attribute anyway
            this.setState({d});
        }
    };
}

export const SwoopArrow = portal(SwoopArrowComponent);
